const STEPS = {
  INIT: 0,
  CREATE_CAMPAIGN: 1,
  CREATE_FROM_CSV: 2,
  MERGE_CAMPAIGNS: 3,
  RUN_QC: 4,
  REDIRECT_TO_CAMPAIGN: 5,
  SUCCESS: 6,
};

const campaignsPage = {
  state: {
    step: STEPS.INIT,
    campaign: null,
    campaignIsNew: false,
    assets: null,
    goingBackwards: false,
    campaignsToBeMerged: [],
    assetActions: null,
    activeCampaignsLoaded: false,
    inactiveCampaignsLoaded: false,
    assetsLoaded: false,
  },
  reducers: {
    reset: (state) => {
      return {
        ...state,
        step: STEPS.INIT,
        campaign: null,
        campaignIsNew: false,
        assets: null,
        goingBackwards: true,
        assetActions: null,
      };
    },
    resetWholeState: (state) => {
      return {
        step: STEPS.INIT,
        campaign: null,
        campaignIsNew: false,
        assets: null,
        goingBackwards: true,
        campaignsToBeMerged: [],
        assetActions: null,
        activeCampaignsLoaded: false,
        inactiveCampaignsLoaded: false,
        assetsLoaded: false,
      };
    },
    onCreateCampaign: (state) => {
      return {
        ...state,
        step: STEPS.CREATE_CAMPAIGN,
        goingBackwards: false,
      };
    },
    onCreateFromCSV: (state) => {
      return {
        ...state,
        step: STEPS.CREATE_FROM_CSV,
        goingBackwards: false,
      };
    },
    onMergeCampaigns: (state, campaign) => {
      return {
        ...state,
        step: STEPS.MERGE_CAMPAIGNS,
        goingBackwards: false,
      };
    },
    setMergeCampaigns: (state, campaignsToBeMerged) => {
      return {
        ...state,
        campaignsToBeMerged,
        goingBackwards: false,
      };
    },
    onRunQC: (state, { assetActions, campaign }) => {
      return {
        ...state,
        step: STEPS.RUN_QC,
        campaignsToBeMerged: [],
        goingBackwards: false,
        assetActions,
        campaign,
      };
    },
    onCampaignRedirect: (state, campaign) => {
      return {
        ...state,
        step: STEPS.REDIRECT_TO_CAMPAIGN,
        campaignsToBeMerged: [],
        goingBackwards: false,
        campaign,
      };
    },
    onActiveCampaignsLoaded: (state) => {
      return {
        ...state,
        activeCampaignsLoaded: true,
      };
    },
    onInactiveCampaignsLoaded: (state) => {
      return {
        ...state,
        inactiveCampaignsLoaded: true,
      };
    },
    onAssetsLoaded: (state) => {
      return {
        ...state,
        assetsLoaded: true,
      };
    },
  },
};

export default campaignsPage;
export { STEPS };
